import React from "react";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function Box({ children }) {
    return (
        <div       
         style={{ 
        display: 'block',
        lineHeight: 1,             
        marginBottom: '8px',
        width: '160px',
      }}         
        >
            {children}
        </div>
    );
}


const ButtonSkeleton = (props) => {

    return (
        <div className="r_buybtn">
            <div className="r_buttonPrice">
            <SkeletonTheme baseColor="#D8DBE0" highlightColor="#EDF1F6" borderRadius={'4px'}>
                    <Skeleton wrapper={Box} height={16} />
                    <Skeleton wrapper={Box} height={31 } />
                </SkeletonTheme>
           </div>
        </div>
    );
}

export default ButtonSkeleton;